import AuctionWizardVehicleSelector from "@/src/components/atoms/VehicleSelectorGroup/AuctionWizardVehicleSelector";
import HomePageVehicleSelector from "@/src/components/atoms/VehicleSelectorGroup/HomePageVehicleSelector";
import { VehicleSelectorNavigationView } from "@/src/components/atoms/VehicleSelectorGroup/vehicleSelector.constants";

import { VehicleType } from "@/src/types/types";

interface VehicleSelectorGroupProps {
  vehicleType: VehicleType;
  navigationView: VehicleSelectorNavigationView;
}

const VehicleSelectorGroup = (props: VehicleSelectorGroupProps) => {
  const { vehicleType, navigationView } = props;

  if (navigationView === "homePageView") {
    return <HomePageVehicleSelector vehicleType={vehicleType} />;
  }

  return <AuctionWizardVehicleSelector vehicleType={vehicleType} />;
};

export default VehicleSelectorGroup;
